import React from 'react'
import { Link, useParams } from 'react-router-dom'

export default function CreateCustomerPending() {
  const { trackingId } = useParams<{ trackingId: string }>()
  const isDevStage = window.location.hostname.toLowerCase().includes('dev.card')
  return (
    <div className="awsui-util-container">
      <div className="awsui-util-container-header">
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-title">
            <h2>Confirmation</h2>
          </div>
        </div>
      </div>
      {`Customer creation is pending. We will
      send you the update. Our tracking id is: ${trackingId}. You may track the
      processing`}
      <Link
        to={`/audit/?query=${encodeURIComponent(
          trackingId
        )}&stage=${encodeURIComponent(isDevStage ? 'beta' : 'prod')}`}
      >
        {'here'}
      </Link>
    </div>
  )
}
